<div class="clientes tab-pane fade show active">
    <div class="cabeceraTabla row">
        <div class="col-12 intro"  *ngIf="!showDireUnits"><p translate>inv.createReceiver.introAdhesions</p></div>
        <div class="col-12 intro" *ngIf="showDireUnits"><p translate>inv.createReceiver.introDires</p></div>

        <div class="col-12 selecClient">
            <label class="form-check-inline" translate>inv.createReceiver.authorization</label> <ui-switch [checked]="showDireUnits" (valueChange)="onValueChange($event)"></ui-switch> <label class="form-check-inline" translate>inv.createReceiver.myunits</label>
        </div>
        <div class="col-12 col-md-5 col-sm-4">
            <label for="buscadorPF" translate>inv.createReceiver.direUnit</label>
            <input type="text" id="buscadorPF" placeholder="{{'inv.createReceiver.searchByNameDire' | translate}}" [(ngModel)]="searchedText" (keyup)="onKeyUp()" class="col-12 buscador">
        </div>

        <div class="col-12 col-md-7 col-sm-8  align-bottom">
            <div class="selectGroupPFNoIE pull-right" *ngIf="isDataSelected()" (change)="openConfirmAssoc()">
                <label class="" translate>inv.createReceiver.selectPFIE</label>
                <select [(ngModel)]="platform"  class="asociarPF custom-select pull-right" placeholder="xxxxx">
                    <option selected disabled translate>inv.createReceiver.selectPF</option>
                    <option *ngFor="let platform of platforms" [ngValue]="platform">
                        {{ platform.name }}
                    </option>
                </select>
            </div>
            <div class="selectGroupPFIE pull-right" *ngIf="isDataSelected()" (change)="openConfirmAssoc()">
                <label class="" translate>inv.createReceiver.selectPFIE</label>
                <select [(ngModel)]="platform"  class="asociarPF custom-select pull-right" placeholder="xxxxx">
                    <option selected disabled translate>inv.createReceiver.selectPF</option>
                    <option *ngFor="let platform of platforms" [ngValue]="platform">
                        {{ platform.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div *ngIf="!showDireUnits">
        <table class="table table-hover table-striped">
            <thead>
            <tr>
                <th scope="col">
                    <label class="form-check-label pseudocheck">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="swSelectAll" (click)="onSelectAllClicked()">

                    </label>
                </th>
                <th scope="col"><span translate>inv.createReceiver.direCode</span></th>
                <th scope="col" class=" d-none d-md-table-cell"><span translate>inv.createReceiver.direName</span></th>
                <th scope="col" class="text-center d-none d-md-table-cell"><span class="" translate>inv.createReceiver.authorizationDate</span></th>
                <th scope="col" class="text-right"><span class="d-none d-md-block" translate>inv.createReceiver.actions</span></th>
            </tr>
            </thead>
            <tbody *ngIf="clientAdhesionList">
                <tr class="noResultFound" *ngIf="clientAdhesionList.items.length === 0">
                    <td colspan="5"><span translate>cli.adhesionList.noResultFound</span></td>
                </tr>
                <tr *ngFor="let clientAdhesion of clientAdhesionList.items | paginate: { itemsPerPage: itemsPerPageAdhesion, currentPage: pAdhesion }; let i=index">
                    <td class="">
                        <label class="form-check-label pseudocheck">
                            <input type="checkbox" class="form-check-input" [(ngModel)]="clientAdhesion.selected">
                            <span></span>
                        </label>

                    </td>
                    <td>{{ clientAdhesion.dire.code }}</td>
                    <td class=" d-none d-md-table-cell"><span class="truncateTD">{{ clientAdhesion.dire.name }}</span></td>
                    <td class="text-center d-none d-md-table-cell">{{ clientAdhesion.createdAt | date: 'dd/MM/yyyy' }}</td>
                    <td class="text-right">
                        <button (click)="onCancelClientAdhesionClicked(clientAdhesion)"  title="{{'inv.createReceiver.cancelService' | translate}}"><i class="fa fa-trash"> <span
                                class="d-none d-lg-inline-block" translate>inv.createReceiver.cancelService</span></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errors && errors.errors.length > 0">
            <span *ngFor="let error of errors.errors">{{ error }}</span>
        </div>
        <div *ngIf="clientAdhesionList.items.length > 0" class="paginador">
            <pagination-controls (pageChange)="pAdhesion = $event" autoHide="true"
                                 previousLabel="{{'inv.list.previous' | translate}}"
                                 nextLabel="{{'inv.list.next' | translate}}" class="pull-right">
            </pagination-controls>

            <div class="controlPaginador pull-left">
                <label class="d-none d-sm-inline-block" translate>inv.list.platformPage</label>
                <select [(ngModel)]="itemsPerPageAdhesion" class="custom-select">
                    <option value="5" selected>5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="1000">1000</option>
                </select>
            </div>
        </div>
    </div>

    <div *ngIf="showDireUnits">
        <table class="table table-hover table-striped">
            <thead>
            <tr>
                <th class="">
                    <label class="form-check-label pseudocheck">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="swSelectAll" (click)="onSelectAllClicked()">

                    </label>
                </th>
                <th scope="col"><span translate>inv.createReceiver.direCode</span></th>
                <th scope="col" class="d-none d-sm-table-cell"><span translate>inv.createReceiver.direName</span></th>
            </tr>
            </thead>
            <tbody *ngIf="clientAdhesionList">
                <tr class="noResultFound" *ngIf="direList.items.length === 0">
                    <td colspan="4"><span translate>cli.adhesionList.noResultFound</span></td>
                </tr>
                <tr *ngFor="let dire of direList.items | paginate: { itemsPerPage: itemsPerPageDire, currentPage: pDire }; let i=index">
                    <td>
                        <label class="form-check-label pseudocheck">
                            <input type="checkbox" class="form-check-input" [(ngModel)]="dire.selected">
                            <span></span>
                        </label>
                    </td>
                    <td>{{ dire.code }}</td>
                    <td class="d-none d-sm-table-cell"><span class="truncateTD">{{ dire.name }}</span></td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errors && errors.errors.length > 0">
            <span *ngFor="let error of errors.errors">{{ error }}</span>
        </div>
        <div *ngIf="direList.items.length > 0" class="paginador">
            <pagination-controls (pageChange)="pDire = $event" autoHide="true"
                                 previousLabel="{{'inv.list.previous' | translate}}"
                                 nextLabel="{{'inv.list.next' | translate}}" class="pull-right">
            </pagination-controls>

            <div class="controlPaginador pull-left">
                <label class="d-none d-sm-inline-block" translate>inv.list.platformPage</label>
                <select [(ngModel)]="itemsPerPageDire" class="custom-select">
                    <option value="5" selected>5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="1000">1000</option>
                </select>
            </div>
        </div>
    </div>
</div>

<!-- MODAL -->
<ng-template #updateClientAdhesion let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate>inv.receiver.modal.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate>inv.receiver.modal.ChangeAdhesion</p>
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>inv.receiver.modal.cancel</button>
            <button type="button" class="btn btn-primary" (click)="c('update')" translate>inv.receiver.modal.accept</button>
        </div>
    </div>
</ng-template>

<!-- MODAL confirm association -->
<ng-template #confirmAssociation let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate="">inv.receiver.modal.association.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p *ngIf="showDireUnits" [innerHTML]="'inv.receiver.modal.association.body' | translate:{ plataforma: platform.name}"></p>
        <p *ngIf="!showDireUnits" [innerHTML]="'inv.receiver.modal.association.body' | translate:{ plataforma: platform.name}"></p>
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>inv.receiver.modal.cancel</button>
            <button type="button" class="btn btn-primary" (click)="c('createAssoc')" translate>inv.receiver.modal.accept</button>
        </div>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-client-list/inv-client-list.component.html